import './auth.css';
import type { Feature } from '../../app/feature';
import { q } from '../../shared/dom';
import { getLang, setLang, translateWithin } from '../../shared/i18n';
import { parseAuthRoute } from './auth-routes';
import { renderLoginScreen } from './login-screen';
import { renderForgotPasswordScreen } from './forgot-password-screen';
import { renderResetPasswordScreen } from './reset-password-screen';

/**
 * Casca das telas públicas. Decide pelo hash qual tela mostrar:
 *   #/login (padrão) · #/forgot · #/reset/<token>
 */
export const authShell: Feature = {
  template: () => `
<div id="auth" hidden>
  <aside class="auth-stage" aria-hidden="true">
    <span class="auth-tag"><i></i><span data-i18n="auth.tag">Estudio de sorteos</span></span>
    <div class="auth-wheel"></div>
    <h1>Rueda de la Fortuna</h1>
    <div class="auth-sub">Apueste Rápido</div>
    <div class="auth-rule"></div>
    <div class="auth-motto" data-i18n="stage.motto">La rueda gira para todos · La Fortuna es ciega</div>
  </aside>
  <section class="auth-panel">
    <div class="auth-card">
      <div class="auth-head">
        <span class="brand-mini"><i></i>Rueda de la Fortuna</span>
        <span class="lang" role="group" aria-label="Idioma">
          <button id="lang-es-auth" aria-pressed="true">ES</button>
          <button id="lang-pt-auth" aria-pressed="false">PT</button>
        </span>
      </div>
      <div id="auth-view"></div>
    </div>
    <div class="auth-foot">Apueste Rápido · <span data-i18n="auth.foot">Plataforma de sorteos en vivo</span></div>
  </section>
</div>`,

  mount() {
    q('#lang-es-auth').onclick = () => setLang('es');
    q('#lang-pt-auth').onclick = () => setLang('pt');
    window.addEventListener('hashchange', () => { if (!q('#auth').hidden) authShell.render(); });
  },

  render() {
    const view = q('#auth-view');
    const route = parseAuthRoute();
    if (route.screen === 'forgot') renderForgotPasswordScreen(view);
    else if (route.screen === 'reset') renderResetPasswordScreen(view, route.token);
    else renderLoginScreen(view);
    q('#lang-es-auth').setAttribute('aria-pressed', String(getLang() === 'es'));
    q('#lang-pt-auth').setAttribute('aria-pressed', String(getLang() === 'pt'));
    translateWithin(view);
  }
};
